import React, { Component } from 'react'
import { Button } from "@blueprintjs/core";
import MarkInterestForm from './MarkInterestForm'
import { connect } from "react-redux";
import { markInterest } from "../../store/my_circles/operations";
import { markingInterest } from "../../store/my_circles/selectors";
import { Translate} from "react-redux-i18n";
import { removeProduct } from "../../store/b2b_button/creators";
import LoadingIndicator from "../../components/LoadingIndicator";
import Div100vh from "react-div-100vh";
import { getB2BProduct } from "../../store/b2b_button/selectors";

class MarkInterestPage extends Component {
    buttonRef = React.createRef();
    sendProductInterest=(values)=>{
        const payload = {
            "email": values.email,
            "address": values.address,
            "product_url": this.props.circle_url
        }

        this.props.markInterest(payload).then(_=>{
            this.props.removeProduct();
        })
    }

    submit=()=>{
        this.buttonRef.current.buttonRef.click();
    }
    
    render() {
        const {marking_interest} = this.props;
        if(!this.props.product){
            return null;
        }

        return (
            <Div100vh className="b2b-100vh-container">
                <div className="b2b-container">
                    <div className="main-content-wrapper mark-interest">
                        <h1><Translate value="b2b.interested_not_ready" /></h1>
                        <p><Translate value="b2b.interested_not_ready_copy" /></p>
                        <MarkInterestForm sendInterest={this.sendProductInterest}  buttonRef={this.buttonRef} />
                    </div>
                    <div className="cta-area">
                        {marking_interest && <LoadingIndicator />}
                        {!marking_interest && (
                        <Button type="button"
                            onClick={this.submit}
                            fill={true}
                            intent="primary"
                            className="cta"
                        >
                            <Translate value="b2b.mark_interest_an_close" dangerousHTML />
                        </Button>
                        )}
                        <div className="cta-helper-text take-me-back" onClick={this.props.removeProduct}>
                            <Translate value="b2b.take_me_back" />                        
                        </div>
                    </div>
                </div>

            </Div100vh>
        )
    }
}

const mapStateToProps = state => ({
    circle_url: `${window.location.origin}${state.router.location.pathname}`,
    product: getB2BProduct(state),
    marking_interest: markingInterest(state)
  });

  const mapDispatchToProps ={
    markInterest,
    removeProduct
  }  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(MarkInterestPage);